<template>
  <div class="bank-account-container">
    <page-header title="Bank Accounts" />
    <div class="spacing-32"></div>
    <div v-if="accountLoading">
      <loader :height="400" />
    </div>
    <b-row v-else>
      <b-col md="8" v-if="bankAccounts.length">
        <div class="bank-account-list-container">
          <list-row-widget
            id="remittance-list"
            v-for="(account, i) in bankAccounts"
            :key="i"
            :data="account"
            :buttonText="$t('remittances.listRemittance.listCardButton')"
            :redirectTo="viewDetails"
          >
            <template v-slot:title>
              <div class="truncate-text mr-2 title-width">
                {{ capitalizeFirstLetter(account.name) }}
              </div>
              <chip
                :class="'bank-status ml-0 ' + getAccountStatus(account)"
                :chipText="getAccountStatus(account)"
              />
            </template>
            <template v-slot:subtitle>
              <div
                class="d-flex drip-body-small color-noble-blue-500 font-weight-700 flex-wrap"
              >
                <div class="mr-2">
                  {{ hidePartialAccountNumber(account.account) }}
                </div>
                <span class="color-sky-blue-500">|</span>
                <div class="mx-2 truncate-text">
                  {{
                    account.beneficiary_name &&
                    account.beneficiary_name.toUpperCase()
                  }}
                </div>
                <span class="color-sky-blue-500">|</span>
                <div class="ml-2">{{ account.currency.toUpperCase() }}</div>
              </div>
            </template>
            <template v-slot:buttonBody>
              <template
                v-if="
                  account.status === 'pending_verification' &&
                  hasPermissionToUpdateBank()
                "
              >
                {{ $t('bank.list.accounts.editButton') }}
                <b-icon-pencil scale="0.9" class="ml-2" />
              </template>
              <template v-else>
                {{ $t('bank.list.accounts.viewButton') }}
                <b-icon-chevron-right scale="0.9" class="ml-2" />
              </template>
            </template>
          </list-row-widget>
          <div class="spacing-24"></div>
        </div>
      </b-col>
      <b-col md="4">
        <add-more-banks-widget />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import userService from '@/services/user'
import exportersService from '@/services/exporters'
import PageHeader from '@/components/common/PageHeader'
import Chip from '@/components/common/Chip'
import AddMoreBanksWidget from '@/components/bank-accounts/AddMoreBanksWidget'
import ListRowWidget from '@/components/common/ListRowWidget'
import { capitalizeFirstLetter } from '@/utils/common'
import Loader from '@/components/common/Loader'
import { ACTIONS, ENTITIES } from '@/utils/constants'

export default {
  errorCaptured: function (err) {
    console.log('Caught error', err.message)
  },
  components: {
    PageHeader,
    Chip,
    AddMoreBanksWidget,
    Loader,
    ListRowWidget
  },
  data() {
    return {
      bankAccounts: [],
      accountLoading: false
    }
  },
  mounted() {
    this.getBankAccounts()
  },
  methods: {
    hasPermissionToUpdateBank() {
      return this.$store.getters.hasActionPermission(
        ENTITIES.BANK,
        ACTIONS.CREATE
      )
    },
    capitalizeFirstLetter(str) {
      return capitalizeFirstLetter(str)
    },
    viewDetails(account) {
      this.$mpTrack('Add Bank - Click view/edit details', {
        status: account.status
      })
      this.$router
        .push({
          name: 'viewBank',
          params: {
            bid: account.id
          }
        })
        .catch((_) => 1)
    },
    getBankAccounts() {
      this.accountLoading = true
      userService
        .fetchAccessToken()
        .then((res) => {
          exportersService
            .fetchBankAccounts(
              res.data.token,
              this.$store.state.account.accountId
            )
            .then((r) => {
              this.bankAccounts = [
                ...r.data['Pending Verification'],
                ...r.data['Verified']
              ]
              this.accountLoading = false
            })
            .catch((e) => {
              this.accountLoading = false
              console.error(e)
            })
        })
        .catch(() => {
          this.accountLoading = false
        })
    },
    getAccountStatus({ status }) {
      return status === 'verified' ? 'Verified' : 'Verification Pending'
    },
    hidePartialAccountNumber(accNumber) {
      return '******' + accNumber.slice(accNumber.length - 4, accNumber.length)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.bank-account-container {
  padding: 40px 108px;
  margin-bottom: 8px;
  @media screen and (max-width: 1024px) {
    padding: 40px 56px;
  }
  @media screen and (max-width: 768px) {
    padding: 40px 24px;
  }
  .bank-account-list-container {
    .bank-account {
      padding: 24px 16px;
      border: 1px solid $sky-blue-400;
      border-radius: 8px;
      .bank-status {
        &.Verified {
          border: 1px solid $spring-green-400;
          background: $spring-green-50;
          color: $noble-blue-500;
        }
        &.Pending {
          border: 1px solid $mustard-yellow-400;
          background: $mustard-yellow-50;
          color: $noble-blue-500;
        }
      }
    }
  }
}
</style>
